import styled from "styled-components";

const Wrapper = styled.div`
    width: 100%;
    color: black;
`;

export default Wrapper;
